@if (!isLoading) {
  <oui-autocomplete
    label="Rechercher un partenaire"
    [options]="partenaireAutocompleteOptions"
    [control]="partenaireControl"
    [allowCustomValue]="true"
    class="width-100pc"
  ></oui-autocomplete>
}
